import { authHeader } from '../helpers';
import handleResponse from './handleResponse';

export const messageModelService = {
    doAction,
    getAll,
    getById,
    _delete,
};

function _delete(id) {
    const requestOptions = {
        method: 'DELETE',
        headers: authHeader()
    };

    return fetch(process.env.REACT_APP_API_ENDPOINT + `/api/message-model/${id}`, requestOptions).then(handleResponse);
}

function doAction(messageModelId, action, data = []) {
    return kick({
        'action': action,
        'messageModelId': messageModelId,
        'data' : data
    });
}

function kick(data) {
    const requestOptions = {
        method: 'POST',
        headers: authHeader(),
        body: JSON.stringify(data)
    };

    return fetch( process.env.REACT_APP_API_ENDPOINT + `/api/message-model-kick`, requestOptions).then(handleResponse);
}

function getAll(departmentIds = [],text = '', withAttachments = false, page = '', per_page='')  {
    const requestOptions = {
        method: 'GET',
        headers: authHeader()
    };

    return fetch(process.env.REACT_APP_API_ENDPOINT + `/api/message-model?departmentIds=${departmentIds.join()}&text=${text}&withAttachments=${withAttachments}&page=${page}&per_page=${per_page}`, requestOptions).then(handleResponse);
}

function getById(id) {
    const requestOptions = {
        method: 'GET',
        headers: authHeader()
    };

    return fetch(process.env.REACT_APP_API_ENDPOINT + `/api/message-model/${id}`, requestOptions).then(handleResponse);
}


